const videoBaseURL = `https://s3.amazonaws.com/files.kaoshinetwork.com/videos/how-to`;
const paymentMethodSteps = [
    'Sign In',
    'Click on Menu',
    'Click on "Profile Settings"',
    'Scroll down to the Payment Methods',
    'Click on "Payment Methods"',
    'Click the "+" button to link your bank account',
    'You can search for your bank by typing its name in the search bar',
    'Select your bank to continue',
    'Attention: Note that the BANK selected is the one that is linked to Interac',
    'Attention: Note that the ACCOUNT selected is the one that is linked to Interac',
    'Click "Continue"',
    'Click "OK"',
    'Your selected bank account has been added as your payment method.',
];

export default [
    {
        title: 'HOW TO ACCEPT REQUESTS ON KAOSHI',
        src: `${videoBaseURL}/Accepting+Requests.mp4`,
        steps: [
            'Sign up/sign in',
            'Click on Menu',
            'Click Request Summary',
            'Click Accept',
            'Click "Decline" to Decline the request',
            'Verify the Requester Information',
            'Click Accept',
            'Click Continue',
            'Click Pay',
            'Payment must be made within 2hrs',
            'Click Continue',
            'Scroll down to select your bank or search for your bank',
            'Click continue',
            'Enter your bank details',
            'Complete the request to proceed',
            'Click paid to confirm payment',
            'Click "OK"',
            'Payment has been successfully made',
        ],
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'PAYMENT METHOD (CANADA)',
        src: `${videoBaseURL}/How+to+Link+a+Diasporan+Bank+-+Payment+Method+(Canada).mp4`,
        steps: paymentMethodSteps,
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'PAYMENT METHOD (USA)',
        src: `${videoBaseURL}/How+to+Link+a+Disaporan+Bank+-+Payment+Method+(USA).mp4`,
        steps: paymentMethodSteps,
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'PAYMENT METHOD (NIGERIA)',
        src: `${videoBaseURL}/How+to+link+your+debit+card.mp4`,
        steps: [
            'Sign up/sign in',
            'Click "Menu"',
            'Click "Profile Settings"',
            'Scroll down to "Payment Method"',
            'Click "Payment Method"',
            'Click the "+" icon to add a debit card',
            'Input your card details',
            'Click "Save"',
            'Click "OK"',
        ],
        country: 'NG',
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'DELIVERY METHOD (NIGERIA)',
        src: `${videoBaseURL}/How+to+Link+your+Nigerian+Bank+-+Delivery+Method.mp4`,
        steps: [
            'Sign up/Sign in',
            'Click Menu',
            'Click "Profile Settings"',
            'Scroll down to "Delivery Method"',
            'Click "Delivery Method"',
            'Click the "+" icon to link your account',
            'Add your bank/mobile money details',
            'Click "Save"',
            'Click "OK"',
        ],
        country: 'NG',
    },
    {
        title: 'HOW TO SET/TURN OFF A RATE ALERT',
        src: `${videoBaseURL}/How+to+set+rate+alert.mp4`,
        steps: [
            'Log in',
            'Click "Menu"',
            'Select "Rate Alert"',
            'Select currency pair',
            'Enter your desired rate',
            'Click the toggle button to enable the alert',
            'Save alert settings',
            'You can add more rate alerts by clicking the "CREATING NEW ALERT" tab',
            'You can turn off the alert by clicking the toggle button',
            'Click the "Remove" button to delete rate alert',
        ],
    },
    {
        title: 'POSTING OFFERS - HOW TO SEND MONEY INTERNATIONALLY WITH KAOSHI',
        src: `${videoBaseURL}/POSTING_OFFERS-HOW_TO_SEND_MONEY_INTERNATIONALLY.mp4`,
        steps: [
            'Sign Up/Sign In',
            'Click the "Send Money Internationally" pane',
            'You can send money From Nigeria, Ghana, Kenya, South Africa',
            'Each Currency pair has an indicated exchange rate and a suggested rate',
            'You can send money to Canada, Finland, France, Germany, Italy, Netherlands, Spain, Sweden, U.S.A, United Kingdom',
            'We are Sending From Nigeria to the United Kingdom',
            'Type in your exchange rate within the allowed range',
            'Select payment method from your registered debit card',
            'Select the amount you want to send',
            'Enter your CVV',
            'Type in the email of the recipient',
            'Confirm the transaction details and amount',
            'If your recipient is not registered, they will gen an email invitation to join Kaoshi and set up their bank account to receive money',
            'Confirm that the name of the recipient matches the email you entered',
            'Click "OK"',
            'You can click the "cancel transaction" button to cancel your transfer while it is still processing',
            'Transaction completed. Transaction can no longer be cancelled',
        ],
    },
    {
        title: 'MATCHING OFFERS - HOW TO TRANSFER MONEY INTERNATIONALLY WITH KAOSHI',
        src: `${videoBaseURL}/MATCHING_OFFERS-HOW_TO_TRANSFER_MONEY_INTERNATIONALLY_WITH_KAOSHI_[UNITED_STATES].mp4`,
        steps: [
            'Sign In',
            'Select the country you want to send money from',
            'Select the country you want to send money to',
            'Select your preferred amount to send',
            'Scroll down to see different money transfer services',
            'Select your preferred payment method',
            'You can select the ACH transfer option',
            'You can select the Debit Card option',
            'You can select the Credit Card option',
            'Select you preferred delivery method',
            'You can select the bank deposit method',
            'You can select the mobile money method',
            'Select your preferred duration',
            'Let us send 50 Great British Pounds from The United Kingdom to Nigeria',
            'Note: All the money transfer services are ranked with the service resulting in the recipient getting the most money',
            'Select your preferred Money Transfer Service',
            'Complete the Payment Recipient Details form with recipient payment details',
            'Click "Continue"',
            'Click "Accept"',
            'Payment must be made within two hours',
            'Click "Pay"',
            'Click "Continue"',
            'Scroll down to select your bank or search for your bank',
            'Click "Continue"',
            'Enter your bank details',
            'Complete the request to proceed',
            'Click paid to confirm payment',
            'Payment has been successfully completed',
        ],
    },
    {
        title: 'MATCHING OFFERS - HOW TO TRANSFER MONEY WITH KAOSHI (UNITED KINGDOM)',
        src: `${videoBaseURL}/MATCHING_OFFERS-HOW_TO_TRANSFER_MONEY_INTERNATIONALLY_WITH_KAOSHI_[UNITED_KINGDOM-WORLDREMIT].mp4`,
        steps: [
            'Sign In',
            'Select the country you want to send money from',
            'Select the country you want to send money to',
            'Select your preferred amount to send',
            'Scroll down to see different money transfer services',
            'Select your preferred payment method',
            'You can select the ACH transfer option',
            'You can select the Debit Card option',
            'You can select the Credit Card option',
            'Select you preferred delivery method',
            'You can select the bank deposit method',
            'You can select the mobile money method',
            'Select your preferred duration',
            'Let us send 50 Great British Pounds from The United Kingdom to Nigeria',
            'Note: All the money transfer services are ranked with the service resulting in the recipient getting the most money',
            'Select your preferred Money Transfer Service',
            'Complete the Payment Recipient Details form with recipient payment details',
            'Click "Continue"',
            'Click "Accept"',
            'Payment must be made within two hours',
            'Click "Pay"',
            'Click "Continue"',
            'Scroll down to select your bank or search for your bank',
            'Click "Continue"',
            'Enter your bank details',
            'Complete the request to proceed',
            'Click paid to confirm payment',
            'Payment has been successfully completed',
        ],
        country: 'GB',
    },
    {
        title: 'HOW TO SEND PAYMENT REQUESTS ON KAOSHI',
        src: `${videoBaseURL}/Sending+Requests.mp4`,
        steps: [
            'Sign In',
            'Select the country you want to request money from',
            'Select the country you want to receive money in',
            'Select your preferred amount to receive',
            'Scroll down to see the different available offers',
            'You can choose your desired payment method & delivery method at the sidebar to display specific transfer options.',
            'Note: All the money transfer services are ranked with the service resulting in the recipient getting the most money',
            'Let us request 50 Great British Pounds from the United Kingdom to Nigeria',
            'Select your preferred money transfer service',
            'Input the email of the benefactor',
            'Select your payment request purpose',
            'Select your preferred delivery method',
            'You can click the toggle button to save Recipient Details',
            'Click "Continue"',
            'Verify the details of your request',
            'Click "Request"',
            'Click "Cancel" to cancel your request',
        ],
    },
    {
        title: 'HOW TO CREATE A KAOSHI ACCOUNT',
        src: `${videoBaseURL}/HOW_TO_CREATE_AN_ACCOUNT_WITH_KAOSHI.mp4`,
        steps: [
            'Fill in your personal information',
            'Enter your name as it appears on your government issued ID or Bank Statement',
            'Select your Date of Birth',
            'Click "Next"',
            'Enter your email address and your preferred password',
            'Click "Next"',
            'Select the location of the bank you want to use',
            'AIM: Send Money',
            'SELECT: Location of bank that has the money',
            'AIM: Receive/Request Money',
            'SELECT: Location of bank money will be paid into',
            'AIM: Transfer money from one account to a different account in another country',
            'SELECT: Location of bank that has the money',
            'John Doe wants to send money from his Canadian account to his Ghanaian account, so he selects Canada',
            'Click "Sign Up"',
            'Click "Ok"',
            'Check your email inbox for an email titled "User Confirmation Link Request"',
            'Click "Click Here" to verify your account',
            'Click "Ok" to continue',
            'You can now sign in to Kaoshi with your verified email and password',
        ],
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'DELIVERY METHOD (USA)',
        src: ``,
        steps: [
            'Sign In',
            'Click on "Menu"',
            'Click on "Profile Settings"',
            'Scroll down',
            'Click on "Delivery Methods"',
            'Click "Ok"',
            'Click the "+" button to link your bank account',
            'Enter the Zelle Email that is linked to not just the bank, but also to the account you are about to add.',
            'Click "Save"',
            'Click "Proceed"',
            'Note: You can search for your bank by typing its name in the search bar',
            'Select your bank to continue',
            'Attention: Note that the BANK selected is the one that is linked to Zelle',
            'Attention: Note that the ACCOUNT selected is the one that is linked to Zelle',
            'Click "Continue"',
            'Click "OK"',
            'Your selected bank account has been added as your payment method.',
        ],
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'DELIVERY METHOD (CANADA)',
        src: ``,
        steps: [
            'Sign In',
            'Click on "Menu"',
            'Click on "Profile Settings"',
            'Scroll down',
            'Click on "Delivery Methods"',
            'Click "Ok"',
            'Click the "+" button to link your bank account',
            'Enter the Interac Email that is linked to not just the bank, but also to the account you are about to add.',
            'Click "Save"',
            'Click "Proceed"',
            'Note: You can search for your bank by typing its name in the search bar',
            'Select your bank to continue',
            'Attention: Note that the BANK selected is the one that is linked to Interac',
            'Attention: Note that the ACCOUNT selected is the one that is linked to Interac',
            'Click "Continue"',
            'Click "OK"',
            'Your selected bank account has been added as your payment method.',
        ],
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'DELIVERY METHOD (EUROPE)',
        src: `${videoBaseURL}/How+to+link+a+bank+-+Delivery+Method+(Europe).mp4`,
        steps: [
            'Login',
            'Click on "Profile Settings"',
            'Click on "Delivery Methods"',
            'Click "Ok"',
            'Click the "+" icon to link your bank account',
            'Note: You can search for your bank by typing its name in the search bar',
            'Select your bank to continue',
            'Verify your identity',
            'Click "OK"',
            'Your selected bank account has been added as your payment method.',
        ],
    },
    {
        title: 'HOW TO LINK A BANK',
        text: 'PAYMENT METHOD (EUROPE)',
        src: `${videoBaseURL}/How+to+link+a+bank+-+Payment+Method+(Europe).mp4`,
        steps: [
            'Login',
            'Click on "Menu"',
            'Click on "Profile Settings"',
            'Scroll down',
            'Click on "Payment Methods"',
            'Click "Ok"',
            'Click the "+" sign to link your bank account',
            'Note: You can search for your bank by typing its name in the search bar',
            'Attention: Note that the bank selected is the bank used for bank transfers',
            'Select your bank',
            'Verify your identity',
            'Click "OK"',
            'Your selected bank account has been added as your payment method.',
        ],
    },
];
